import cn from 'classnames'
import React, { FC } from 'react'
import { RowProps, ColumnProps } from './types'
import s from './grid.module.css'

const Row: FC<RowProps> = ({ children, className }) => {
  return <div className={cn(s.row, className)}>{children}</div>
}

const Column: FC<ColumnProps> = ({ children, className }) => {
  return <div className={cn(s.column, className)}>{children}</div>
}

export default { Row, Column }
